import { getTask, Task } from '@admiin-com/ds-graphql';
import { useMemo } from 'react';
import { gql, useQuery } from '@apollo/client';
import { convertFromBackendTask } from '../../../helpers/tasks';
import { useEntityId } from '../../hooks/useEntityContext/useEntityContext';

interface UseGetTaskProps {
  id: string | null;
  forceRefresh?: boolean;
}

export const useGetTask = ({ id, forceRefresh = false }: UseGetTaskProps) => {
  const entityId = useEntityId();

  const { data, refetch } = useQuery(gql(getTask), {
    variables: {
      id: id,
      entityId: entityId,
    },
    skip: !id || !entityId,
    fetchPolicy: forceRefresh ? 'network-only' : 'cache-first',
  });

  const selectedTask = useMemo(
    () => convertFromBackendTask(data?.getTask) || null,
    [data]
  );

  return { task: selectedTask, refetch };
};
